import { render, staticRenderFns } from "./doctorsSelector.vue?vue&type=template&id=010ad04e"
import script from "./doctorsSelector.vue?vue&type=script&lang=js"
export * from "./doctorsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports